import { render, staticRenderFns } from "./CollectionStep.vue?vue&type=template&id=788f4229&scoped=true&"
import script from "./CollectionStep.vue?vue&type=script&lang=js&"
export * from "./CollectionStep.vue?vue&type=script&lang=js&"
import style0 from "./CollectionStep.vue?vue&type=style&index=0&id=788f4229&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788f4229",
  null
  
)

export default component.exports